import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFormOctagon: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconFormOctagon"><Path d="M15.0029 2C15.7322 2 16.4315 2.28998 16.9473 2.80566L21.1943 7.05273C21.71 7.56845 22 8.26775 22 8.99707V15.0029C22 15.7322 21.71 16.4315 21.1943 16.9473L16.9473 21.1943C16.4315 21.71 15.7322 22 15.0029 22H8.99707C8.26775 22 7.56845 21.71 7.05273 21.1943L2.80566 16.9473C2.28998 16.4315 2 15.7322 2 15.0029V8.99707C2 8.26775 2.28998 7.56845 2.80566 7.05273L7.05273 2.80566C7.56845 2.28998 8.26775 2 8.99707 2H15.0029Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFormOctagon;
